import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "style"
    }}>{`style`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Specifies an inline stylesheet.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/style"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/style`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<style>
    .highlight { color: red; }
</style>
`}</code></pre>
    <h2 {...{
      "id": "attributes"
    }}>{`Attributes`}</h2>
    <p>{`The following attributes are unsupported and ignored:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`type`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`media`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`nonce`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`title`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      